<template>
  <div class="auth" v-if="loader" @click="close">
    <div class="searchfile">
      <span>
        <svg width="100px" height="100px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"
          preserveAspectRatio="xMidYMid" class="lds-dual-ring"
          style="background: rgba(0, 0, 0, 0) none repeat scroll 0% 0%;">
          <circle cx="50" cy="50" fill="none" stroke-linecap="round" r="20" stroke-width="4" stroke="#039aed"
            stroke-dasharray="31.41592653589793 31.41592653589793">
            <animateTransform attributeName="transform" type="rotate" calcMode="linear" values="0 50 50;360 50 50"
              keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite"></animateTransform>
          </circle>
        </svg>
      </span>
      <span>Searching files....</span>
    </div>
  </div>
</template>
<style scoped>
.searchfile {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: #fff;
  border-radius: 3px;
  position: relative;
  padding: 1em 2em;
  height: 180px;
  width: 490px;
}
</style>
<script>
import cookies from '@/services/cookies'
export default {
  data() {
    return {
      loader: false
    }
  },
  methods: {
    load() {
      this.loader = true
    },
    close() {
      this.loader = false
    }
  }
}
</script>